import { render, staticRenderFns } from "./SettingsTranslations.vue?vue&type=template&id=5ee41cb9&scoped=true"
import script from "./SettingsTranslations.vue?vue&type=script&lang=js"
export * from "./SettingsTranslations.vue?vue&type=script&lang=js"
import style0 from "./SettingsTranslations.vue?vue&type=style&index=0&id=5ee41cb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee41cb9",
  null
  
)

export default component.exports